import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mobile-navigation" }
const _hoisted_2 = { class: "mobile-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "•••", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "mobile-tabbar",
  "aria-label": "主要功能"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "mobile-menu-grid" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mobile-service-contact" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  src: "/images/customerServices.png",
  alt: "客服二维码"
}
const _hoisted_13 = { key: 3 }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_LanguageSelect = _resolveComponent("LanguageSelect")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (!_ctx.hasTabs)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "icon-button",
            "aria-label": "返回",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _createVNode(_component_svg_icon, { icon: "back" })
          ]))
        : (_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "mobile-logo",
              src: _ctx.logo,
              alt: ""
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createBlock(_component_svg_icon, {
              key: 2,
              icon: "home1",
              class: "mobile-logo"
            })),
      _createElementVNode("strong", null, _toDisplayString(_ctx.hasTabs ? _ctx.title : _ctx.pageTitle), 1),
      _createElementVNode("button", {
        type: "button",
        class: "icon-button mobile-menu-toggle",
        "aria-label": "打开功能菜单",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openMenu()))
      }, _hoisted_5)
    ]),
    (_ctx.hasTabs)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.title,
              type: "button",
              class: _normalizeClass({active:tab.menus.some(menu=>menu.path===_ctx.path)}),
              onClick: ($event: any) => (_ctx.selectTab(tab))
            }, [
              _createVNode(_component_svg_icon, {
                icon: tab.icon
              }, null, 8, ["icon"]),
              _createElementVNode("span", null, _toDisplayString(tab.title), 1)
            ], 10, _hoisted_7))
          }), 128)),
          (_ctx.personalVisible)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass({active:_ctx.path.startsWith('/main/cuscenter')}),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('personal')))
              }, [
                _createVNode(_component_svg_icon, { icon: "person" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.pageText('common.mobile.1')), 1)
              ], 2))
            : (_ctx.loggedIn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('security')))
                }, [
                  _createVNode(_component_svg_icon, { icon: "info" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.pageText('common.mobile.2')), 1)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('login')))
                }, [
                  _createVNode(_component_svg_icon, { icon: "person" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.pageText('common.mobile.3')), 1)
                ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      visible: _ctx.menuOpen,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.menuOpen) = $event)),
      placement: "bottom",
      title: _ctx.translateUi(_ctx.groupTitle) || '全部功能',
      height: "auto",
      class: "mobile-menu-drawer"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LanguageSelect),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedMenus, (menu) => {
            return (_openBlock(), _createElementBlock("button", {
              key: menu.path,
              type: "button",
              class: _normalizeClass({active:_ctx.path===menu.path}),
              onClick: ($event: any) => (_ctx.navigate(menu))
            }, _toDisplayString(menu.title), 11, _hoisted_9))
          }), 128)),
          (!_ctx.groupTitle)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.personalVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.action('personal')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.1')), 1))
                  : _createCommentVNode("", true),
                (_ctx.scaleVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.action('scale')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.4')), 1))
                  : _createCommentVNode("", true),
                (_ctx.rechargeVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "recharge-promotion",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.action('recharge')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.5')), 1))
                  : _createCommentVNode("", true),
                (_ctx.memberVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.action('member')))
                    }, _toDisplayString(_ctx.translateUi(_ctx.memberTitle)), 1))
                  : _createCommentVNode("", true),
                (_ctx.serviceVisible)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 4,
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.serviceOpen=true))
                    }, _toDisplayString(_ctx.pageText('common.mobile.6')), 1))
                  : _createCommentVNode("", true),
                (_ctx.loggedIn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.action('security')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.2')), 1))
                  : _createCommentVNode("", true),
                (_ctx.loggedIn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 6,
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.action('password')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.7')), 1))
                  : _createCommentVNode("", true),
                (_ctx.loggedIn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 7,
                      type: "button",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.action('logout')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.8')), 1))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 8,
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.action('login')))
                    }, _toDisplayString(_ctx.pageText('common.mobile.9')), 1))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.serviceOpen,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.serviceOpen) = $event)),
      title: _ctx.pageText('common.mobile.6'),
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.serviceUrl.includes('https'))
            ? (_openBlock(), _createBlock(_component_qrcode_vue, {
                key: 0,
                value: _ctx.serviceUrl,
                size: 220,
                type: "image/png"
              }, null, 8, ["value"]))
            : (_ctx.serviceUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.serviceUrl,
                  alt: "客服二维码"
                }, null, 8, _hoisted_11))
              : (_ctx.platform)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.pageText('common.mobile.10')), 1)),
          (_ctx.servicePhone)
            ? (_openBlock(), _createElementBlock("a", {
                key: 4,
                href: 'tel:'+_ctx.servicePhone
              }, _toDisplayString(_ctx.servicePhone), 9, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}